import React, { Component } from 'react';
import { ChangePassword , MfaEmailConfirm} from './subcomponents'
import { SlPageTitle, SlButton, SlSectionTitle } from './editors'
import { AccountAPI } from '../_services';
import { history } from '../_helpers';

export class ChangePasswordPage extends Component {
    //static displayName = MyProfile.name;

         constructor(props) {
           super(props);
           this.state = {
               currentStep : 0,
               mfaToken : '', 
               formError: ''
           };
           this.mfaConfirmSuccess = this.mfaConfirmSuccess.bind(this);
           this.handleBack = this.handleBack.bind(this);
           this.executeChangePassword = this.executeChangePassword.bind(this);
        
         }

    handleBack(){

    }
    executeChangePassword(password, newPassword){
        AccountAPI.changeUserPassword(password, newPassword, this.state.mfaToken)
            .then(response => {
                if(response.status <= 2){
                    history.push('/log-out')
                }
                else{
                    this.setState({formError : response.message})
                }
            })
    }
    mfaConfirmSuccess(tokenId){
        this.setState({currentStep:1, mfaToken:tokenId});
    }

    componentDidMount() {
        //Request MfaCode 
      }

    render() {
        const renderState = (step) => {
            switch(step){
                case 0: //Confirm MFA to email 
                    return (<MfaEmailConfirm mfaConfirmed={this.mfaConfirmSuccess}/>);
                default: //Change Password 
                    return (<ChangePassword executeChangePassword={this.executeChangePassword} formError={this.state.formError}/>); 
            }
        }
        return (
            <div>
                <div id="backBtnContainer" hidden >
                    <SlButton name='Back' onClick={this.handleBack}/>
                </div>
                <SlPageTitle pageName='MyProfile'/>
                <SlSectionTitle sectionName="SectionChangePassword"/>
                {renderState(this.state.currentStep)}

            </div>
        );
    }
}
